export default {
  PO_ADJUST_EVENT_LOGS: {
    path: '/po-adjust-event-logs',
    name: 'po_adjust_event_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/AdjustEventLogs')
  },
  PO_COHORT_ANALYSIS: {
    path: '/po-cohort-analysis',
    name: 'po_cohort_analysis',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/CohortAnalysis/CohortAnalysisIndex.vue')
  },
  PO_COHORT_ANALYSIS_EXPORT: {
    type: 'function',
    path: 'po_cohort_analysis_export',
    name: 'po_cohort_analysis_export',
    permission: 'po_cohort_analysis_export',
    meta: {
      requiresAuth: true
    }
  },
  PO_AFFILIATE_PARTNERS: {
    path: '/po-affiliate-partners',
    name: 'po_affiliate_partners',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/AffiliatePartners/AffiliatePartnersIndex')
  },
  PO_USERS: {
    path: '/po-users',
    name: 'po_users',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/Users/UsersIndex')
  },
  PO_USERS_EXPORT: {
    type: 'function',
    path: 'po_users_export',
    name: 'po_users_export',
    permission: 'po_users_export',
    meta: {
      requiresAuth: true
    }
  },
  PO_USERS_DELETE: {
    type: 'function',
    path: 'po_users_delete',
    name: 'po_users_delete',
    permission: 'po_users_delete',
    meta: {
      requiresAuth: true
    }
  },
  PO_USER_DETAILS: {
    path: '/po-user/:userId',
    name: 'po_user_details',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'po',
      title: 'User Details',
      order: 0,
      main: true
    },
    component: () => import('@po_views/Users/UserDetails')
  },
  PO_TRANSACTIONS: {
    path: '/po-transactions',
    name: 'po_transactions',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'po',
      title: 'Transactions',
      order: 1
    },
    component: () => import('@po_views/Transactions/TransactionsIndex')
  },
  PO_CLAIMS: {
    path: '/po-claims',
    name: 'po_claims',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'po',
      title: 'Claims',
      order: 2
    },
    component: () => import('@po_views/Claims/ClaimsIndex')
  },
  PO_CONFIG_PAYOUT_CONFIRMATION: {
    path: '/po-config-payout-confirmation',
    name: 'po_config_payout_confirmation',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/Configs/PayoutConfirmations/PayoutConfirmationsIndex')
  },
  PO_LEADERBOARDS: {
    path: '/po-leaderboards',
    name: 'po_leaderboards',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/Leaderboards/LeaderboardsIndex')
  },
  PO_TRIGGERS: {
    path: '/po-triggers',
    name: 'po_triggers',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/Triggers/TriggersIndex')
  },
  PO_PERFORMANCE: {
    path: '/po-performance',
    name: 'po_performance',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/Performance/PerformanceIndex')
  },
  PO_PERFORMANCE_EXPORT: {
    type: 'function',
    path: 'po_performance_export',
    name: 'po_performance_export',
    permission: 'po_performance_export',
    meta: {
      requiresAuth: true
    }
  },
  PO_VIP_USERS: {
    path: '/po-vip-users',
    name: 'po_vip_users',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/Users/UsersVIP')
  },
  PO_EMAILS: {
    path: '/po-emails',
    name: 'po_emails',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'po',
      title: 'E-Mails',
      order: 3
    },
    component: () => import('@po_views/Emails/EmailsIndex')
  },
  PO_REWARDS: {
    path: '/po-rewards',
    name: 'po_rewards',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/Rewards')
  },
  PO_OFFER_WALL_PERFORMANCE: {
    path: '/po-offerwall-performance',
    name: 'po_offer_wall_performance',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'po',
      title: 'Offerwall Performance',
      order: 6
    },
    component: () => import('@po_views/OfferWallPerformance')
  },
  PO_BONUS_CODES: {
    path: '/po-bonus-codes',
    name: 'po_bonus_codes',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/BonusCodes/BonusCodesIndex.vue')
  },
  PO_EMAIL_STATISTICS: {
    path: '/po-email-statistics',
    name: 'po_email_statistics',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/Emails/EmailStatisticsIndex.vue')
  },
  PO_BONUS_CODE_REDEMPTIONS: {
    path: '/po-bonus-code-redemptions',
    name: 'po_bonus_code_redemptions',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'po',
      title: 'Bonus Codes',
      order: 4
    },
    component: () => import('@po_views/BonusCodeRedemptions')
  },
  PO_BOGDAN_BONUS: {
    path: '/po-bogdan-bonus',
    name: 'po_bogdan_bonus',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/BogdanBonus')
  },
  PO_VALUE_REPORT: {
    path: '/po-value-report',
    name: 'po_value_report',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/ValueReport')
  },
  PO_LEVELS: {
    path: '/po-levels',
    name: 'po_levels',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/Level')
  },
  PO_LOG_SPEND: {
    path: '/po-log-spend',
    name: 'po_log_spend',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/LogSpend')
  },
  PO_SETTINGS: {
    path: '/po-settings',
    name: 'po_settings',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/Settings')
  },
  PO_FRONTEND_SETTINGS: {
    path: '/po-frontend-settings',
    name: 'po_frontend_settings',
    meta: {
      requiresAuth: true
    },
    props: { project: 'prime-opinion' },
    component: () => import('@ps_views/shared/frontend-settings/FrontendSettingsIndex.vue')
  },
  PO_CAMPAIGN_SETTINGS: {
    path: '/po-campaign-settings',
    name: 'po_campaign_settings',
    meta: { requiresAuth: true },
    props: { project: 'prime-opinion' },
    component: () => import('@ps_views/shared/campaign-settings/CampaignSettingsIndex.vue')
  },
  PO_TUNE_REJECTION_SETTINGS: {
    path: '/po-tune-rejection-settings',
    name: 'po_tune_rejection_settings',
    meta: { requiresAuth: true },
    props: { project: 'prime-opinion' },
    component: () => import('@ps_views/shared/tune-rejection-settings/TuneRejectionSettingsIndex.vue')
  },
  PO_TUNE_REJECTIONS: {
    path: '/po-tune-rejections',
    name: 'po_tune_rejections',
    meta: { requiresAuth: true },
    props: { project: 'prime-opinion' },
    component: () => import('@ps_views/shared/tune-rejections/TuneRejectionsIndex.vue')
  },
  PO_ADJUST_CONFIG: {
    path: '/po-adjust-config',
    name: 'po_adjust_config',
    meta: {
      requiresAuth: true
    },
    props: { project: 'prime-opinion' },
    component: () => import('@ps_views/shared/adjust-config/AdjustConfigIndex.vue')
  },
  PO_DYNAMIC_CAMPAIGNS: {
    path: '/po-dynamic-campaigns',
    name: 'po_dynamic_campaigns_main',
    meta: {
      requiresAuth: true
    },
    props: { project: 'prime-opinion' },
    component: () => import('@po_views/DynamicCampaigns')
  },
  PO_DYNAMIC_CAMPAIGNS_EMAILS: {
    path: '/po-dynamic-campaigns/emails',
    name: 'po_dynamic_campaigns_emails',
    meta: {
      requiresAuth: true
    },
    props: { project: 'prime-opinion' },
    component: () => import('@po_views/DynamicCampaigns/Pages/Emails/CampaignsEmails.vue')
  },
  PO_DYNAMIC_CAMPAIGNS_EMAILS_CREATE: {
    path: '/po-dynamic-campaigns/emails/create',
    name: 'po_dynamic_campaigns_emails_create',
    meta: {
      requiresAuth: true
    },
    props: { project: 'prime-opinion' },
    component: () => import('@po_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsCreateAndEdit.vue')
  },
  PO_DYNAMIC_CAMPAIGNS_EMAILS_EDIT: {
    path: '/po-dynamic-campaigns/emails/edit/:id',
    name: 'po_dynamic_campaigns_emails_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'prime-opinion' },
    component: () => import('@po_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsCreateAndEdit.vue')
  },
  PO_DYNAMIC_CAMPAIGNS_EMAILS_TRANSLATIONS_EDIT: {
    path: '/po-dynamic-campaigns/emails/:id/translations/edit/:language_code',
    name: 'po_dynamic_campaigns_emails_translations_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'prime-opinion' },
    component: () => import('@po_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsTranslationsEdit.vue')
  },
  PO_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS: {
    path: '/po-dynamic-campaigns/push-notifications',
    name: 'po_dynamic_campaigns_push_notifications',
    meta: {
      requiresAuth: true
    },
    props: { project: 'prime-opinion' },
    component: () => import('@po_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotifications.vue')
  },
  PO_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_CREATE: {
    path: '/po-dynamic-campaigns/push-notifications/create',
    name: 'po_dynamic_campaigns_push_notifications_create',
    meta: {
      requiresAuth: true
    },
    props: { project: 'prime-opinion' },
    component: () => import('@po_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsCreateAndEdit.vue')
  },
  PO_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_EDIT: {
    path: '/po-dynamic-campaigns/push-notifications/edit/:id',
    name: 'po_dynamic_campaigns_push_notifications_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'prime-opinion' },
    component: () => import('@po_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsCreateAndEdit.vue')
  },
  PO_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_TRANSLATIONS_EDIT: {
    path: '/po-dynamic-campaigns/push-notifications/:id/translations/edit/:language_code',
    name: 'po_dynamic_campaigns_push_notifications_translations_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'prime-opinion' },
    component: () => import('@po_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsTranslationsEdit.vue')
  },
  PO_USER_STREAK_LENGTH: {
    type: 'function',
    path: 'po_user_streak_length',
    name: 'po_user_streak_length',
    permission: 'po_user_streak_length',
    meta: {
      requiresAuth: true
    }
  },
  PO_USER_REWARD_ELIGIBILITY_LOGS: {
    path: '/po-user-reward-eligibility-logs',
    name: 'po_user_reward_eligibility_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@po_views/Users/UserRewardEligibilityLogs')
  },
  PO_USER_CREDIT: {
    type: 'function',
    path: 'po_user_credit',
    name: 'po_user_credit',
    permission: 'po_user_credit',
    meta: {
      requiresAuth: true
    }
  },
  PO_USER_LEVEL: {
    type: 'function',
    path: 'po_user_level',
    name: 'po_user_level',
    permission: 'po_user_level',
    meta: {
      requiresAuth: true
    }
  },
  PO_OVERWRITE_ELIGIBLE: {
    type: 'function',
    path: 'po_overwrite_eligible',
    name: 'po_overwrite_eligible',
    permission: 'po_overwrite_eligible',
    meta: {
      requiresAuth: true
    }
  }
}
